import React, { useState, useEffect } from 'react';
import './ArtCraft.css';

// Import images for Art & Craft
import artcraft1 from '../assets/ART (1).webp';
import artcraft2 from '../assets/ART (2).webp';
import artcraft3 from '../assets/ART (3).webp';
import artcraft4 from '../assets/ART (4).webp';

const ArtCraft = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const artcraftImages = [artcraft1, artcraft2, artcraft3, artcraft4];

  useEffect(() => {
    setIsVisible(true);
    
    // Auto-slide images every 3 seconds
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === artcraftImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const handleDotClick = (index) => {
    setCurrentImageIndex(index);
  };

  const handlePrevImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === 0 ? artcraftImages.length - 1 : prevIndex - 1
    );
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === artcraftImages.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="artcraft-container">
       {/* Banner Section with Background Image */}
      <section className="inner-bannerlib">
        <div className="banner-container">
          <h1>ART & CRAFT</h1>
        </div>
      </section>

      {/* Breadcrumb */}
      <section className="breadcrumb-section">
        <div className="breadcrumb-container">
          <ul className="breadcrumb-list">
            <li><a href="/">Home</a></li>
            <li>/</li>
            <li>Art & Craft</li>
          </ul>
        </div>
      </section>

      {/* Main Content */}
      <div className="artcraft-main-content">
        <div className="artcraft-content-wrapper">
          {/* Left Side - Text Content */}
          <div className={`artcraft-text-content ${isVisible ? 'artcraft-visible' : ''}`}>
            <h2 className="artcraft-main-heading">ART & CRAFT</h2>
            
            <p className="artcraft-section-text">
              The Splashes of Color Reverberate with the Diversity & Vividity of Human Emotion in the Art 
              Room at the Junior Level. Individual styles and techniques get honed and displayed at the 
              Middle and Senior School Level.
            </p>

            <p className="artcraft-section-text">
              Our Art & Craft program encourages students to express their creativity through various mediums 
              including painting, drawing, sculpture, and mixed media. The program is designed to develop 
              artistic skills, enhance visual perception, and foster creative thinking.
            </p>

            <p className="artcraft-section-text">
              Students explore different art forms and techniques such as watercolor painting, acrylic painting, 
              charcoal drawing, clay modeling, paper crafts, fabric painting, and more. The art room is equipped 
              with all necessary materials and tools to support student creativity.
            </p>

            <p className="artcraft-section-text">
              Regular art exhibitions, competitions, and workshops are organized to showcase student talent and 
              provide exposure to contemporary art practices. Students also learn about famous artists, art 
              history, and different cultural art traditions.
            </p>

            <p className="artcraft-section-text">
              The program emphasizes individual expression while also encouraging collaboration through group 
              projects. Students develop fine motor skills, spatial awareness, color theory knowledge, and an 
              appreciation for aesthetics that benefits them across all areas of learning.
            </p>
          </div>

          {/* Right Side - Image Slider */}
          <div className={`artcraft-image-slider ${isVisible ? 'artcraft-visible' : ''}`}>
            <div className="artcraft-slider-container">
              {artcraftImages.map((image, index) => (
                <img
                  key={index}
                  src={image}
                  alt={`Art & Craft ${index + 1}`}
                  className={`artcraft-slider-image ${
                    index === currentImageIndex ? 'artcraft-active' : ''
                  }`}
                />
              ))}
              
              {/* Navigation Arrows */}
              <button 
                className="artcraft-slider-arrow artcraft-arrow-left"
                onClick={handlePrevImage}
              >
                ‹
              </button>
              <button 
                className="artcraft-slider-arrow artcraft-arrow-right"
                onClick={handleNextImage}
              >
                ›
              </button>
              
              {/* Slider Dots */}
              <div className="artcraft-slider-dots">
                {artcraftImages.map((_, index) => (
                  <span
                    key={index}
                    className={`artcraft-dot ${
                      index === currentImageIndex ? 'artcraft-dot-active' : ''
                    }`}
                    onClick={() => handleDotClick(index)}
                  ></span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArtCraft;